import moment from "moment";

export default {
  install(Vue) {
    Vue.filter("formatDateMMM", value => {
      return moment(value).format("MMM Do H:mm");
    });

    Vue.filter("formatDate", value => {
      return moment(value).format("YYYY-MM-DD");
    });

    Vue.filter("capitalize", value => {
      return value[0].toUpperCase() + value.slice(1);
    });

    Vue.filter("id36", id => parseInt(id, 10).toString(36));
    Vue.filter("id10", id => parseInt(id, 36).toString(10));

    Vue.filter("view", id => "/v/" + parseInt(id, 10).toString(36));
    Vue.filter("celeb", id => "/celeb/" + parseInt(id, 10).toString(36));

    Vue.filter("truncate", (text, length, suffix) => {
      if (text.length < length) suffix = "";
      return text.substring(0, length) + suffix;
    });
  }
};
